export const environment = {
  production: true,
  hmr: false,
  version: '1.0.0-dev',
  serverUrl: 'https://extranet-api.pso.pl/api/v1', // Due to corporate proxy setup
  authUrl: 'https://extranet-api.pso.pl',
  assetsUrl: '/assets',
  clientId: 1,
  clientSecret: 'mMRM3fkzLE2z2CyIkcuLabdn3scscStkHnY59aWE',
  defaultLanguage: 'pl-PL',
  supportedLanguages: ['pl-PL'],
  assetUrl: '/assets',
  userSnap: '//api.usersnap.com/load/71486bcb-3ed9-4056-995e-af1ddecb6ad7.js',
  pusher: {
    host: 'extranet-api.pso.pl',
    port: '6001',
    key: 'key-extranet',
    authEndpoint: 'https://extranet-api.pso.pl/broadcasting/auth',
    cluster: 'eu',
    encrypted: true,
  },
  logWebsocketEvents: true,
  logIntervals: false,
  showLegacyPages: false,
  showLibraryPages: false,
  hotjar: false,
  showSentryDialog: false,
  sentryEnvironment: 'production',
  serviceWorker: true,
  google_forms_survey_id_workshop: '1FAIpQLScp0oPTofh_2XjWU5529GBlWs59XTIjMZ4HwDCbZ626kp2tCw',
  google_forms_field_id_workshop: 'entry.873996089',
  google_forms_widget_text_workshop: 'Wypełnij ankietę w zakresie systemu flotowego Extranet i odbierz nagrody!',
  google_forms_survey_id_afl: '1FAIpQLSetZknTwPMamrVe7b9qKb7sJ9h2KqlG9OvLomC7o68oJsRvHg',
  google_forms_field_id_afl: 'entry.1735162991',
  google_forms_widget_text_afl: 'Wypełnij ankietę w zakresie systemu flotowego Extranet i odbierz nagrody!',
  showWymianaOponWidget: false,
  workshopOfflineNotificationsIntervalInSeconds: 600,
};
